module.exports = __webpack_public_path__ + "static/media/296.0545ecbd.svg";